<template>
  <div>
    <v-select
      v-model="newValue"
      :disabled="disableWorkspaces"
      :items="workspaces"
      label="Workspaces"
      item-text="name"
      item-value="code"
      color="blue"
      multiple
      item-color="info"
      menu-props="light"
      clearable
      :rules="[(v) => (!!v && v.length > 0) || 'Required']"
      hide-details
      @change="updateWorkspaceSelectList"
    />

    <v-checkbox
      v-model="disableWorkspaces"
      label="Appliquer à tous les workspaces"
      color="success"
      @change="changeDisableWorkspaces"
    />
  </div>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue';
import { useStore } from 'vue2-helpers/vuex';
import { sortSelect } from '../../../utils/index';

// eslint-disable-next-line no-undef
const props = defineProps({
  value: { type: Array, default: () => [] },
  sort: { type: String, default: 'asc' } // Current status
});

const store = useStore();

// eslint-disable-next-line no-undef
const emit = defineEmits(['input']);

const newValue = ref(props.value);

const disableWorkspaces = ref(false);

const workspaces = computed(() => {
  let ws = store.getters.liveWorkspaces.filter(w => !['merch', 'eole'].includes(w.code));
  if (props.sort) {
    ws = sortSelect(ws, props.sort, 'name');
  }

  return ws;
});
watch(newValue, val => {
  emit('input', val || null);
}, { deep: true });

onMounted(() => {
  if (newValue.value && newValue.value.includes('*')) {
    disableWorkspaces.value = true;
  }
});

const updateWorkspaceSelectList = workspacesSelected => {
  store.commit('updateWorkspacesSelected', workspacesSelected);
};

const changeDisableWorkspaces = enabled => {
  if (enabled) {
    newValue.value = ['*'];
    return;
  }
  newValue.value = [];
};

updateWorkspaceSelectList(props.value ? props.value : []);
</script>

<style>
</style>
